import React, { useMemo } from 'react';

import { getChainIcon } from 'components/balances/chains/chainIcons/chainIcons';
import { ChainsFromConfig } from 'config/configType';

import stargateBridgeIcon from './stargate.svg';

export function StargateExplorerDoubleIcon({
  chain,
  chainType,
  size = 24,
  inlineFlex,
}: {
  chain: ChainsFromConfig | undefined;
  chainType: 'source' | 'target';
  size?: number;
  inlineFlex?: boolean;
}) {
  const offsetPx = useMemo(() => Math.round(size / 3), [size]);
  return (
    <div
      style={{
        marginLeft: -offsetPx,
        display: inlineFlex ? 'inline-flex' : 'flex',
        alignItems: 'center',
      }}
    >
      {chainType === 'source' && chain && (
        <img
          src={getChainIcon(chain)}
          height={size}
          style={{ marginLeft: offsetPx, marginRight: -offsetPx }}
        />
      )}
      <img
        src={stargateBridgeIcon}
        style={{
          height: size,
          background: 'var(--elevation-light)',
          borderRadius: '50%',
          // outline: '1px solid var(--elevation-light)',
          boxShadow: '-2px 0 3px var(--elevation-light)',
          boxSizing: 'border-box',
          ...(chainType === 'target'
            ? {
                zIndex: 123,
                position: 'relative',
                boxShadow: '2px 0 3px var(--elevation-light)',
              }
            : {}),
        }}
      />
      {chainType === 'target' && chain && (
        <img
          src={getChainIcon(chain)}
          height={size}
          style={{ marginLeft: -offsetPx, marginRight: offsetPx }}
        />
      )}
    </div>
  );
}
